import { BaseModel } from "@puntaje/shared/core"

export class GrupoRecursoTipoCategoria extends BaseModel {
    grupo_recurso_tipo_categoria: string
    recurso_type: string
}
